"use strict";

module.exports = /*@ngInject*/function ($resource, $q, ConfigService, LokiService, MOBILE) {
  var _ConfigService$getCon = ConfigService.getConfig(),
    INSPECT_URL = _ConfigService$getCon.INSPECT_URL;
  var service = $resource("".concat(INSPECT_URL, "/api/routing/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/routing/:id")
    },
    updateBasicDetails: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/routing/:id/basic-details")
    },
    getRoutingGroupByProgram: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/routing/program/:programId"),
      isArray: 1
    },
    getFromServer: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/routing/:id")
    },
    getUniqGroups: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/routing/find-uniq-groups"),
      isArray: 1
    },
    upsertGroupName: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/routing/:id/name/update/:action")
    },
    upsertPerson: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/routing/:id/people/update/:action")
    }
  });
  service.get = function (options, cb) {
    if (MOBILE) {
      return LokiService.collection('routingGroup').then(function (collection) {
        var result = collection.findOne({
          _id: options.id
        });
        return cb ? cb(result) : result;
      });
    }
    return service.getFromServer({
      id: options.id
    });
  };
  return service;
};